export default __webpack_public_path__ + "static/media/digit_span_male_2.e0739f17.png";